import { render } from "./Danfe.vue?vue&type=template&id=5484c8fe&scoped=true"
import script from "./Danfe.vue?vue&type=script&lang=js"
export * from "./Danfe.vue?vue&type=script&lang=js"

import "./Danfe.vue?vue&type=style&index=0&id=5484c8fe&scoped=true&lang=css"

import exportComponent from "/var/www/ambientaly/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5484c8fe"]])

export default __exports__